import { Button, Flex } from "monday-ui-react-core";

type Props = {
  onRun: () => void;
  onClear: () => void;
  runDisabled: boolean;
  clearDisabled: boolean;
  loading: boolean;
};

export function ButtonBar({ onRun, onClear, runDisabled, clearDisabled, loading = false }: Props) {
  return (
    <Flex gap={Flex.gaps.SMALL} justify={Flex.justify.END}>
      <Button kind={Button.kinds.PRIMARY} onClick={onRun} disabled={runDisabled || loading} loading={loading}>
        Run
      </Button>
      <Button kind={Button.kinds.SECONDARY} onClick={onClear} disabled={clearDisabled || loading}>
        Clear
      </Button>
    </Flex>
  );
}
